import AlignIcon from "@redotech/redo-icons/align-horizontal-center-02.svg";
import CursorOutlinedIcon from "@redotech/redo-icons/cursor-01.svg";
import FullscreenIcon from "@redotech/redo-icons/expand-05_filled.svg";
import HandIcon from "@redotech/redo-icons/hand_filled.svg";
import UndoIcon from "@redotech/redo-icons/refresh-ccw-01_filled.svg";
import RedoIcon from "@redotech/redo-icons/refresh-cw-01_filled.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";
import * as styles from "../new-flow-editor.module.css";

type FlowEditorToolbarProps = {
  isSelectMode: boolean;
  toggleSelectMode: () => void;
  toggleGrabMode: () => void;
  toggleFullscreen: () => void;
  handleUndoClick: () => void;
  handleRedoClick: () => void;
  resetNodePositions: () => void;
  canUndo: boolean;
  canRedo: boolean;
  isMac: boolean;
};

export const FlowEditorToolbar = memo(function FlowEditorToolbar({
  isSelectMode,
  toggleSelectMode,
  toggleGrabMode,
  toggleFullscreen,
  handleUndoClick,
  handleRedoClick,
  resetNodePositions,
  canUndo,
  canRedo,
  isMac,
}: FlowEditorToolbarProps) {
  return (
    <Flex className={styles.centeredToolbar} gap="sm">
      <RedoButton
        hierarchy="tertiary"
        IconLeading={CursorOutlinedIcon}
        onClick={toggleSelectMode}
        pressed={isSelectMode}
        size="md"
        type="button"
      />
      <Tooltip arrow title="Hold ⎵">
        <div className={styles.buttonContainer}>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={HandIcon}
            onClick={toggleGrabMode}
            pressed={!isSelectMode}
            size="md"
            type="button"
          />
        </div>
      </Tooltip>
      <div className={styles.toolbarSeparator} />
      <Tooltip arrow title="Zoom out">
        <div className={styles.buttonContainer}>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={FullscreenIcon}
            onClick={toggleFullscreen}
            size="md"
            type="button"
          />
        </div>
      </Tooltip>
      <Tooltip arrow title={`Undo (${isMac ? "⌘" : "Ctrl"}+Z)`}>
        <div className={styles.buttonContainer}>
          <RedoButton
            disabled={!canUndo}
            hierarchy="tertiary"
            IconLeading={UndoIcon}
            onClick={handleUndoClick}
            size="md"
            type="button"
          />
        </div>
      </Tooltip>
      <Tooltip arrow title={`Redo (${isMac ? "⌘+Shift" : "Ctrl+Shift"}+Z)`}>
        <div className={styles.buttonContainer}>
          <RedoButton
            disabled={!canRedo}
            hierarchy="tertiary"
            IconLeading={RedoIcon}
            onClick={handleRedoClick}
            size="md"
            type="button"
          />
        </div>
      </Tooltip>
      <Tooltip arrow title="Auto align">
        <div className={styles.buttonContainer}>
          <RedoButton
            hierarchy="tertiary"
            IconLeading={AlignIcon}
            onClick={resetNodePositions}
            size="md"
            type="button"
          />
        </div>
      </Tooltip>
    </Flex>
  );
});
